// Formats an ISO date string (YYYY-MM-DD, from the native date input) as
// e.g. "Mar 5, 2026". Anything else (legacy free-text deadlines, empty
// values) is returned unchanged so old requests keep displaying correctly.
export function formatDeadline(value) {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return value || "—";
  const [year, month, day] = value.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
